//import p5 from 'p5';
/* global userCredentialAjaxUrl */
/* global checkPostalCodeAjaxObject */

import woocommerceReturnOrder from './woocommerceReturnOrder';

jQuery(document.body).on('wc_fragments_loaded wc_fragments_refreshed', function () {
  refreshMiniCartBadge();
});

export default {
  init() {
    // JavaScript to be fired on all pages

    // $('[data-ws-blob]').wsBlob();
    // $('.ws-carrousel').wsCarrousel();

    // $('.ws-header').wsHeader();
    $('.mobile-menu').wsMenu({
      openButton: '.mobile > .top > .mobile-menu-button',
    });
    // $('.mobile-account-menu').wsAccountMenu({
    //   openButton: $('.mobile-account-menu-button'),
    // });
    $('.wolky-select2').select2({
      width: '100%',
    });

    closeWolkyNotice();
    initModalAccountMenu();
    //initializeMobileSearchBar();
    initializeProductImageSliders();
    mobileMenuController();
    loginDropdownDelay();
    UspCarousel();
    HideUspBarOnScroll();
    b2bPriceSwitch();
    birthday();
    initializeSearchClearButton();
    if ($('.loyalty-counter')[0]) {
      loyaltyspinner();
    }
    initializeMiniCart();
    //initializeCategoryFilterLinks();
    storeCreditAdditionalInformation();
    initializeDataLayer();

    if (sessionStorage.getItem('userData') === null || sessionStorage.getItem('userDataRefresh') === 'true') {
      getUserInformationAjaxCall();
    }
    monitorUserLogin();
    initPostcodeChecker();
    
    // Initialize guest return form if present on the page
    if ($('.guest-return-form').length > 0) {
      woocommerceReturnOrder.init();
    }
  },
  finalize() {
    storeCreditAdditionalInformation();
    fillInEmailField();
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

export var closeWolkyNotice = () => {
  $('.woocommerce-store-notice__dismiss-link').click(function () {
    $(this).hide();
  });
}

export var openMaintenanceProducts = () => {
  $('.show-maintenance').click(function () {
    $('.maintenance-products-modal').show();
    $('.modal-background').show();
    $('.maintenance-products h2 .product-name').text($(this).attr('data-product'));
    $('.maintenance-products-content').empty();
    $('.maintenance-products-content').append($(this).siblings('.product-maintenance-products').html());
  });
}

export var closeModal = () => {
  $('.modal-background').click(function (e) {
    if (e.target != this) {
      return;
    }
    $('.reserve-modal').hide();
    $('.modal-background').hide();
    closeMaintenanceProducts();
  });
}

export var initModalAccountMenu = () => {
  let myAccountLoginContainer = $('.my-account-login-container');
  if (myAccountLoginContainer.has('.show')) {
    $('#ws-site-container').click(function () {
      myAccountLoginContainer.removeClass('show');
    });
  }
}

export var closeMaintenanceProducts = () => {
  $('.modal-background').hide();
  $('.maintenance-products-modal').hide();
}

export var initializeMiniCart = () => {
  /*
  let widget_shopping_cart_content_container = $('#widget_shopping_cart_content_container');
  $('header.header .desktop .shopping_cart').hover(function () {
    let state = widget_shopping_cart_content_container.data('mini-cart-state');
    if (state === 'loading' || state === 'loaded') {
      return;
    }

    widget_shopping_cart_content_container.data('mini-cart-state', 'loading');
    var data = {
      action: 'ws_mini_cart',
    };
    //* global woof_ajaxurl
    jQuery.post(woof_ajaxurl, data, function (content) {
      content = jQuery.parseJSON(content);
      console.log(content);

      widget_shopping_cart_content_container.data('mini-cart-state', 'loaded');
      widget_shopping_cart_content_container.html(content.mini_cart);
    });
  });
  */

  //let miniCartParent = $('header.header .desktop .shopping_cart');
  let miniCartParent = $('#widget_shopping_cart_content_container');
  $(document.body).on('added_to_cart removed_from_cart', function () { // event, fragments, cart_hash ) {
    //console.log(miniCartParent);
    miniCartParent.addClass('show');
    setTimeout(function () {
      miniCartParent.removeClass('show')
    }, 3000);
  });
}

export var refreshMiniCartBadge = () => {
  let items = $('#widget_shopping_cart_content_container .woocommerce-mini-cart-item');
  let badge = $('.shopping_cart .badge');
  let cart_item_counter = $('.cart_item_counter');

  let quantity = 0;
  items.each(function () {
    quantity += $(this).data('quantity');
  });

  cart_item_counter.text('(' + quantity +' ' + $.trim(cart_item_counter.text().replace(/[^a-zA-Z ]/g, '')) + ')');

  badge.text(quantity);
  if (quantity > 0) {
    badge.show();
  } else {
    badge.hide();
  }
};

export var initializeMobileSearchBar = () => {
  let mobileSearchIcon = $('.mobile .mobile-search-icon');
  let mobileSearchBar = $('.mobile .search .bar');

  mobileSearchIcon.click(function () {
    mobileSearchIcon.hide();
    mobileSearchBar.show();
  });

  $(document).click(function (e) {
    if (!mobileSearchIcon.is(e.target) && !mobileSearchBar.is(e.target) && mobileSearchBar.has(e.target).length === 0) {
      mobileSearchIcon.show();
      mobileSearchBar.hide();
    }
  });
}

export var mobileMenuController = () => {
  let switchMobile = $('.language-switcher-mobile');
  let mobileLanguages = $('.other-languages-mobile');
  let mobileBackground = $('.mobile-background');

  $(switchMobile).click(function () {
    $(mobileLanguages).toggle();
    $(mobileBackground).fadeToggle('fast');
  });
}

export var loyaltyspinner = () => {
  var $loyalty = parseInt(jQuery('.loyalty-counter').text());
  if ($loyalty <= 0) {
    $loyalty = 0;
  }
  var $lower = $loyalty / 2;
  var circle = document.querySelector('#loyalty-progress');
  var radius = circle.r.baseVal.value;
  var circumference = radius * 2 * Math.PI;
  circle.style.strokeDasharray = `${circumference} ${circumference}`;
  circle.style.strokeDashoffset = `${circumference}`;

  function setProgress(percent) {
    const offset = circumference - percent / 100 * circumference;
    circle.style.strokeDashoffset = offset;
  }

  setProgress($lower);
}


export var initializeProductImageSliders = () => {
  let initSlick = () => {
    let uninitializedSliders = $('.ws-product-image-slider:not(.slick-initialized)');
    if (uninitializedSliders.length > 0) {
      uninitializedSliders.slick({
        swipeToSlide: true,
        prevArrow: '<div class="slick-prev"><div class="prev-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i></div></div>',
        nextArrow: '<div class="slick-next"><div class="next-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i></div></div>',
      });
      uninitializedSliders.on('click', '.slick-prev, .slick-next', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      });
    }
  }

  if ($('body').hasClass('archive')) {
    $(document).on('woof-ajax-form-redrawing', initSlick);
  }

  setTimeout(initSlick, 500);
}

export var loginDropdownDelay = () => {
  let loginContainer = $('.nav-icons').find('.my-account-login-container');
  let usernameField = $('.nav-icons').find('input[name="username"]');
  let passwordField = $('.nav-icons').find('input[name="password"]');

  $(document).mouseup(function(e) {
    if (!loginContainer.is(e.target) && loginContainer.has(e.target).length === 0) {
      loginContainer.removeClass('active');
    }
  });

  loginContainer.click(function() {
    loginContainer.addClass('active');
  });

  usernameField.focus(function () {
    loginContainer.addClass('active');
  });
  usernameField.focusout(function () {
    loginContainer.removeClass('active');
  });

  passwordField.focus(function () {
    loginContainer.addClass('active');
  });
  passwordField.focusout(function () {
    loginContainer.removeClass('active');
  });

  // my-account-login-container
}

/* Object that contains global accessible functions */
window.WSGlobalFunctions = {
  debounce: function debounce(incomingFunction, delay) {
    let timer = null;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        incomingFunction.apply(context, args);
      }, delay);
    };
  },
}

export var initializeCategoryFilterLinks = () => {
  setCategoryFilterLinks();

  //console.log(e.originalEvent.key);

  // This triggers when localStorage has been changed
  $(window).on('storage', function (e) {

    if (e.originalEvent.key !== 'wsFilterValues') {
      return;
    }

    setCategoryFilterLinks();
  });

  // This triggers when the filters have been changed
  $(window).on('wsFilterValuesChange', function () {
    //console.log('itewoks!');
    setCategoryFilterLinks();
  });
}

// Set the hrefs for links to category pages to include the current filters
export var setCategoryFilterLinks = () => {
  let filterValues = JSON.parse(localStorage.getItem('wsFilterValues'));

  let filterGet = [];

  for (let key in filterValues) {
    let val = filterValues[key];
    filterGet.push(key + '=' + val);
  }

  if (filterGet.length === 0) {
    return;
  }

  $('ul.product-categories li.cat-item a, .header .menu-item-object-product_cat a').each(function () {
    let el = $(this);
    let originalHref = el.attr('href');

    if (typeof originalHref === 'undefined' || originalHref === '') {
      // Do not do anything with empty/unset links
      return;
    }

    if (el.data('original-href')) {
      originalHref = el.data('original-href');
    } else {
      el.data('original-href', originalHref);
    }
    let href = originalHref + '?swoof=1&' + filterGet.join('&');
    el.attr('href', href);
  });
}

export var getUserInformationAjaxCall = () => {
  $.ajax({
    url: userCredentialAjaxUrl.ajax_url, // Here goes the AJAX endpoint.
    type: 'post',
    data: $(this),
    success: function (response) {

      sessionStorage.removeItem('userDataRefresh');

      /* If user is not logged in set UserData to false */
      if (response === false) {
        sessionStorage.setItem('userData', 'false');
        return;
      }

      /* If user is logged in, set user information in UserData storage*/
      sessionStorage.setItem('userData', JSON.stringify({
        name: response.name,
        age: response.age,
        birthDay: response.birthday,
      }));

    },
    fail: function (err) {
      console.log(err);
    },
  });
}

export var monitorUserLogin = () => {
  $('.woocommerce-form-login__submit, .woocommerce-form-register__submit').on('click', function () {
    sessionStorage.setItem('userDataRefresh', 'true');
  });
}

export var storeCreditAdditionalInformation = () => {
  $(document).ajaxStop(function() {
    let additionalInformation = $('.additional-information');
    additionalInformation.on('mouseenter', function () {
      $(this).parent().find($('.additional-information-text')).show();
    });
    additionalInformation.on('mouseleave', function() {
      $(this).parent().find($('.additional-information-text')).hide();
    });
  });
    let additionalInformation = $('.additional-information');
  additionalInformation.on('mouseenter', function () {
    $(this).parent().find($('.additional-information-text')).show();
  });
  additionalInformation.on('mouseleave', function() {
    $(this).parent().find($('.additional-information-text')).hide();
  });
}

export var fillInEmailField = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const email = urlParams.get('email');
  if (email) {
    $('.checkout-step-1 .woocommerce-input-wrapper #billing_email ').val(email);
    $('.checkout-step-1 #createaccount_field .woocommerce-input-wrapper .checkbox #createaccount').prop('checked', true);
    $('.wolkyAndMeWatchOutBar div .login-register-text').hide();
    $('.wolkyAndMeWatchOutBar p').css('margin', 'revert');
    $('.desktop-only .store-credit-block .store-credit-amount p .register-login-text').hide();
    $(document).ajaxStop(function () {
      $('.desktop-only .store-credit-block .store-credit-amount p .register-login-text').hide();
    });
  }
}

export var HideUspBarOnScroll = () => {
  const $header = jQuery('header.header');

  if (!$header.length) {
    return;
  }

  let lastScrollTop = 0;

  jQuery(window).on('scroll', function() {
    if($('body').hasClass('woocommerce-checkout') ||
      $('body').hasClass('make-a-choice') ||
      $('body').hasClass('maak-keuze') ||
      $('body').hasClass('auswahl')
      && $(window).width() <= '640') {
      if($header.hasClass('scrolled-down')) {
        $header.removeClass('scrolled-down');
      }
      return;
    }

    const scrollTop = jQuery(this).scrollTop();

    if (scrollTop > lastScrollTop && scrollTop > $header.outerHeight()) {
      $header.addClass('scrolled-down');
    } else {
      $header.removeClass('scrolled-down');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
}

export var UspCarousel = () => {
  const intervalDuration = 4000;
  const usps = jQuery('header.header .mobile .usp-bar .usp');

  let myIndex = 0;
  UspsCarousel();

  function UspsCarousel() {
    usps.not(':eq(' + myIndex + ')').hide();
    usps.eq(myIndex).show();

    myIndex++;
    if (myIndex >= usps.length) {
      myIndex = 0;
    }

    setTimeout(UspsCarousel, intervalDuration);
  }
}

export var initializeDataLayer = () => {
  $(document).on('click', function (e) {
    let $targetElement = $(e.target);

    if ($targetElement.closest('[name=tinvwl-remove]').length) {
      const productData = $targetElement.closest('[name=tinvwl-remove]').data('product_data');

      if (productData) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'remove_from_wishlist',
          ...productData,
        });

        // eslint-disable-next-line no-undef
        klaviyo.push(['track', 'wishlist_removed', productData]);
      }
    }

    if ($targetElement.closest('.tinvwl_add_to_wishlist_button').length) {
      const $wishListProductId = $targetElement.data('tinv-wl-product');

      const viewItemListEvent = window.dataLayer.find(event => event.event === 'view_item_list');
      const viewItemEvent = window.dataLayer.find(event => event.event === 'view_item');

      if (viewItemListEvent) {
        const items = viewItemListEvent.items;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.item_id === $wishListProductId) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'add_to_wishlist',
              ...item,
            });

            // eslint-disable-next-line no-undef
            klaviyo.push(['track', 'wishlist_removed', item]);
          }
        }
      }

      if (viewItemEvent) {
        const items = viewItemEvent.ecommerce.items;

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_wishlist',
            ...item,
          });

          // eslint-disable-next-line no-undef
          klaviyo.push(['track', 'wishlist_removed', item]);
        }
      }
    }

    if ($targetElement.closest('.single_add_to_cart_button:not(.disabled)').length) {
      const $productForm = $targetElement.closest('form.cart');

      if (!$productForm.length) {
        return true;
      }

      let $productVariantId = $productForm.find('[name=variation_id]');

      if ($productVariantId.length > 0) {
        const $productData = $productForm.find('[name=product_data]');

        if (!$productData.length) {
          return true;
        }

        let productData = JSON.parse($productData.val());

        if($productForm.find('.b2b-table').length) {

          $('.qty_input').each(function() {
            const $input = $(this);

            if($input.val() > 0) {
              productData.id = $input.data('product-id');
              productData.variant_id = $input.data('variation-id');
              productData.size = $input.data('product-size');
              productData.quantity = $input.val();

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'add_to_cart',
                ...productData,
                value: productData.price * productData.quantity,
              });
            }
          });
        } else {
          productData.quantity = $productForm.find('[name=quantity]').val() || 1;
          productData.size = $productForm.find('[name=attribute_pa_size]').val();
          productData.item_colour = $productForm.find('[name=attribute_pa_color').val();
          productData.variant_id = $productForm.find('.single_add_to_cart_button').data('product_id');

          if (isNaN(productData.quantity)) {
            productData.quantity = 1;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ...productData,
            value: productData.price * productData.quantity,
          });
        }
      } else {
        const $productData = $productForm.find('[name=product_data]');

        if (!$productData.length) {
          return true;
        }

        let productData = JSON.parse($productData.val());

        productData.quantity = $productForm.find('[name=quantity]').val() || 1;

        if (isNaN(productData.quantity)) {
          productData.quantity = 1;
        }

        productData.variant_id = $productForm.data('product_id');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ...productData,
          value: productData.price * productData.quantity,
        });
      }
    }

    if ($targetElement.closest('.mini_cart_item a.remove, .product-remove a').length) {
      const $clickElement = $targetElement.closest('.mini_cart_item a.remove, .product-remove a');
      const $productData = $clickElement.data('product_data');

      if (!$productData) {
        return true;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'remove_from_cart',
        ...$productData,
      });
    }
  });
}

export var b2bPriceSwitch = function() {
  jQuery(document).ready(function($) {
    const b2bToggle = $('.b2b-toggle');

    if (b2bToggle.length) {
      b2bToggle.on('change', function() {
        const cookieValue = this.checked ? 'on' : 'off';
        document.cookie = `show_purchase_price=${cookieValue}; path=/; max-age=2592000`;
        location.reload();
      });
    }
  });
};

export var birthday = function() {
  jQuery(document).ready(function($) {
    var $dob = $('#account_date_of_birth');

    if (!$dob.length) return;

    var format = $dob.data('format');
    var separator = format.indexOf('-') > -1 ? '-' :
      format.indexOf('/') > -1 ? '/' :
        format.indexOf('.') > -1 ? '.' : '-';

    $dob.on('input', function() {
      var val = $dob.val().replace(/\D/g, '');
      var newVal = '';

      if (val.length >= 1) {
        var day = val.substring(0, 2);
        if (day.length === 1 && parseInt(day) > 3) {
          day = '0' + day;
        }
        newVal += day;
        if (day.length === 2) newVal += separator;
      }

      if (val.length >= 3) {
        var month = val.substring(2, 4);
        if (month.length === 1 && parseInt(month) > 1) {
          month = '0' + month;
        }
        newVal += month;
        if (month.length === 2) newVal += separator;
      }

      if (val.length >= 5) {
        var year = val.substring(4, 8);
        newVal += year;
      }

      $dob.val(newVal);
    });

    $dob.on('keydown', function(e) {
      if (e.key === 'Backspace') {
        var val = $dob.val();
        if (val.endsWith(separator)) {
          $dob.val(val.slice(0, -1));
        }
      }
    });
  });
}

export var initializeSearchClearButton = () => {
  const $searchInput = $('.search input[type="search"]');
  const $clearBtn = $('<button type="button" class="clear-btn" style="display:none;">Wissen</button>');

  if (!$('.search .clear-btn').length) {
    $searchInput.after($clearBtn);
  }

  const toggleClearButton = function () {
    const $this = $(this);
    const $btn = $this.siblings('.clear-btn');
    if ($this.val().length > 0) {
      $btn.show();
    } else {
      $btn.hide();
    }
  };

  $(document).on('input change focus', '.search input[type="search"]', toggleClearButton);

  $(document).on('click', '.search .clear-btn', function () {
    const $input = $(this).siblings('input[type="search"]');
    $input.val('').focus().trigger('input');
  });
  $(document).on('click', '.hr-close-btn', function () {
    $('.search .clear-btn').hide();
  });
};

export var initPostcodeChecker = () => {
  let billingCountryField = $('#billing_country_field');
  let billingSelectedCountry = billingCountryField.find(':selected').val();
  let billingStreet = $('#billing_street');
  let billingCity = $('#billing_city');
  let billingPostalCode = $('#billing_postcode');
  let billingHouseNumber = $('#billing_house_number');
  let billingCountryFieldValue = $('#billing_country');
  let billingHouseNumberField = $('#billing_house_number_field');
  let billingPostcodeField = $('#billing_postcode_field');
  let billingCityField = $('#billing_city_field');
  let billingStreetField = $('#billing_street_field');

  if (billingSelectedCountry === 'NL') {
    billingHouseNumberField.detach().insertAfter(billingCountryField);
    billingPostcodeField.detach().insertAfter(billingCountryField);
  }

  billingCountryFieldValue.on('change',function() {
    let billingSelectedCountry = billingCountryFieldValue.find(':selected').val();
    // Delay because the html elements need to load.
    if (billingSelectedCountry === 'NL') {
      billingHouseNumberField.detach().insertAfter(billingCountryField);
      billingPostcodeField.detach().insertAfter(billingCountryField);
    } else {
      billingHouseNumberField.detach().insertAfter(billingStreetField);
      billingPostcodeField.detach().insertBefore(billingCityField);
    }
  });

  postcodeChecker(billingSelectedCountry, billingStreet, billingCity, billingPostalCode, billingHouseNumber);

  let shippingCountryField = $('#shipping_country_field');
  let shippingSelectedCountry = shippingCountryField.find(':selected').val();
  let shippingStreet = $('#shipping_street');
  let shippingCity = $('#shipping_city');
  let shippingPostalCode = $('#shipping_postcode');
  let shippingHouseNumber = $('#shipping_house_number');
  let shippingCountryFieldValue = $('#shipping_country');
  let shippingHouseNumberField = $('#shipping_house_number_field');
  let shippingPostcodeField = $('#shipping_postcode_field');
  let shippingCityField = $('#shipping_city_field');
  let shippingStreetField = $('#shipping_street_field');

  if (shippingSelectedCountry === 'NL') {
    shippingHouseNumberField.detach().insertAfter(shippingCountryField);
    shippingPostcodeField.detach().insertAfter(shippingCountryField);
  }

  shippingCountryFieldValue.on('change',function() {
    let shippingSelectedCountry = shippingCountryFieldValue.find(':selected').val();
    // Delay because the html elements need to load.
    if (shippingSelectedCountry === 'NL') {
      shippingHouseNumberField.detach().insertAfter(shippingCountryField);
      shippingPostcodeField.detach().insertAfter(shippingCountryField);
    } else {
      shippingHouseNumberField.detach().insertAfter(shippingStreetField);
      shippingPostcodeField.detach().insertBefore(shippingCityField);
    }
  });

  postcodeChecker(shippingSelectedCountry, shippingStreet, shippingCity, shippingPostalCode, shippingHouseNumber);

  function postcodeChecker (elCountry, elStreet, elCity, elPostalCode, elHouseNumber) {
    if(elCountry === 'NL') {
      $(elPostalCode).on('input', window.WSGlobalFunctions.debounce(function(){
        getAddress();
      }, 500));

      $(elHouseNumber).on('input', window.WSGlobalFunctions.debounce(function(){
        getAddress();
      }, 500));
    }

    function getAddress() {
      let postalCodeLength = elPostalCode.val().replace(/\s/g, '').length;

      let houseNumberLength = elHouseNumber.val().length;
      let houseNumber = elHouseNumber.val().replace(/\D/g,'');
      let houseLetter = elHouseNumber.val().replace(/[0-9]/g, '');

      if (postalCodeLength === 6 && houseNumberLength > 0) {
        getPostcodeData(elPostalCode.val(), houseNumber, houseLetter);
      }
    }

    function getPostcodeData(postalCode, houseNumber, houseLetter) {
      $.ajax({
        url: checkPostalCodeAjaxObject.ajaxurl,
        data: {
          action: 'checkPostalCode',
          'postalCode': postalCode,
          'houseNumber': houseNumber,
          'houseLetter': houseLetter,
        },
        type: 'POST',
        success: function (response) {
          if (response.success === true) {
            if(!response.data.failed) {
              elCity.val(response.data.city);
              elStreet.val(response.data.street);

              elStreet.change();
              elCity.change();
              elPostalCode.change();
              elHouseNumber.change();
            }
          }
        },
      });
    }
  }
}
